import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import './style.css';

export interface AboutUsPageProps extends RouteComponentProps<{}> {}

export interface AboutUsPageState {
  /* empty*/
}

export class AboutUsPage extends React.Component<
  AboutUsPageProps,
  AboutUsPageState
> {
  render() {
    return (
      <main className="about-us plain-content-page" role="main">
        <h1 className="about-us-header plain-content-page-header">About Us</h1>

        <h2>About Edge of Play</h2>
        <p>
          Edge of Play, formed in late 2017, is an online coaching resource,
          providing football coaches with hundreds of football coaching videos
          from the grassroots and professional game.
        </p>
        <p>
          Our website is subscription based and features videos from grassroots
          coaches, elite level clubs, academies and professional players all
          sharing exciting ideas and insights.
        </p>
        <p>
          The site allows you to link in with your social media profiles to
          share content with peers, clubs and players. Our vision is to build a
          global, inclusive, online community of coaches: learning, interacting
          and creating, together.
        </p>
        <p>
          It is through our work with our clubs, that we have become acutely
          aware of the challenges facing amateur, semi-pro and even professional
          coaches. We know that in coaching (like most other jobs) people are
          always looking for new content to ensure their players remain in love
          with the game; to keep them engaged, learning, developing, and most
          importantly having fun.
        </p>
        <p>
          However, we are also aware that not everyone has the same
          circumstances, opportunities, or environment in which to coach.
          Therefore we are to provide the best service for the lowest cost!
          Whether you are a professional, academy or grassroots coach, or simply
          a mum or dad wanting to practice with your son or daughter in the back
          garden, Edge of Play will provide the same inclusive experience.
        </p>

        <h2>Who we are</h2>
        <p>
          We are lifelong friends and FA qualified coaches: Jack Norbury and
          James Stokes. Football coaching is our passion and we want to share
          this with the largest possible audience with an aim to support, guide
          and promote sports coaching all around the world. Alongside our
          extensive years of coaching, our careers covered roles in teaching and
          IT which gave us the perfect skill set to provide an online coaching
          resource.
        </p>
      </main>
    );
  }
}

export default AboutUsPage;



// WEBPACK FOOTER //
// ./src/app/containers/AboutUsPage/index.tsx